import { useHotkeys } from 'react-hotkeys-hook';
import { useAppDispatch, useAppSelector } from '../../../store';
import { outputActions } from '../../output/slice';
import { Button } from './Button';
import { ThemeChooser } from './ThemeChooser';
import { EyeSlashIcon } from '@heroicons/react/24/solid';
import { FadeToBlackIcon } from '../icons/FadeToBlackIcon';

export const LiveToolbar = () => {

  const blanked = useAppSelector(state => state.output.blanked);
  const ftbActive = useAppSelector(state => state.output.fadeToBlack);

  const dispatch = useAppDispatch();

  const toggleBlank = () => dispatch(outputActions.setBlanked(!blanked));
  const toggleFTB = () => dispatch(outputActions.setFadeToBlack(!ftbActive));

  useHotkeys('esc', toggleBlank);
  useHotkeys('shift+esc', toggleFTB, { preventDefault: true });

  return (
    <div className='flex items-center p-2 min-h-16'>
      <h2 className='text-2xl'>
        Live
      </h2>
      <ThemeChooser />
      <Button
        active={blanked}
        className='items-center ml-2'
        grow={false}
        onClick={toggleBlank}
      >
        <EyeSlashIcon className='size-5 mr-1' />
        Clear
      </Button>
      <Button
        active={ftbActive}
        className='items-center'
        grow={false}
        onClick={toggleFTB}
      >
        <FadeToBlackIcon className='size-5 mr-1' />
        Black
      </Button>
    </div>
  );
};
